<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space clickabe" @click="msgAlerta=null"><span class="text">{{ msgAlerta }}</span></div>


    <div class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item-char10 info-card">
                <span>Número</span>
                <strong class="right">{{ Funcoes.formatInteger(objView.cdos) }}</strong>
            </div>

            <div class="form-item-char10 info-card">
                <span>Data</span>
                <strong class="center">{{ Funcoes.formatDateFromJson(objView.dtabertura) }}</strong>
            </div>

            <div class="form-item info-card">
                <span>Dados</span>
                <strong>{{ objView.nmos }}</strong>
            </div>

            <div class="form-item-char40 info-card">
                <span>Situação</span>
                <strong class="center">{{ objView.nmstatus }}</strong>
            </div>
            
            <div class="form-item-char20 info-card info-card--highlight">
                <span>Valor Orçamento</span>
                <strong class="right">R$ {{ Funcoes.formatDecimal(objView.orcamento_valor) }}</strong>
            </div>
        </div>


        <div class="row row-space">
            <div class="form-item info-card">
                <span>Equipamento/Veículo</span>
                <strong>{{ objView.nmequipamento }}</strong>
            </div>
            
            <div class="form-item-char10 info-card">
                <span>Placa</span>
                <strong class="center">{{ objView.placa }}</strong>
            </div>
            
            <div class="form-item info-card">
                <span>Fornecedor</span>
                <strong>{{ objView.nmfornecedor }}</strong>
            </div>
            
            <div class="form-item-char20 info-card info-card--highlight">
                <span>Valor Aprovado</span>
                <strong class="right">R$ {{ Funcoes.formatDecimal(objView.aprovacao_valor) }}</strong>
            </div>
        </div>

        <div class="row-end">
            <button v-if="objView.orcamento_idanexo" class="btn-small" @click="baixarAnexo(objView.orcamento_idanexo)">Orçamento</button>
            <button v-if="objView.execucao_idanexo" class="btn-small" @click="baixarAnexo(objView.execucao_idanexo)">Documento</button>
            <button class="btn-small" @click="imprimirAF">Emitir AF</button>
            <button class="btn-small" @click="closeForm">Retornar</button>
        </div>
    </div>


    <div v-if="lsItensServico.length>0" class="form-panel row-space">
        <div class="form-panel-header">SERVIÇOS SOLICITADOS</div>
        <table>
            <thead><tr>
                <th>Código</th>
                <th>Nome/Descrição</th>
                <th>Status</th>
            </tr></thead>
            <tbody>
                <tr v-for="(obj, index) in lsItensServico" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                    <td class="col-width-integer right">{{ Funcoes.formatInteger(obj.cdservico) }}</td>
                    <td>{{ obj.nmservico }}</td>
                    <td class="col-width-char20 center">{{ statusServico(obj) }}</td>
                </tr>
            </tbody>
        </table>
    </div>


    <div v-if="lsItensOrcamento.length>0" class="form-panel">
        <div class="form-panel-header">ITENS DO ORÇAMENTO</div>
        <table>
            <thead><tr>
                <th>Ordem</th>
                <th>Item</th>
                <th>Horas</th>
                <th>Total</th>
                <th>Peças</th>
                <th>Orçado</th>
                <th>Autorizado</th>
            </tr></thead>
            <tbody>
                <tr v-for="(obj, index) in lsItensOrcamento" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                    <td class="col-width-integer right">{{ obj.ordem }}</td>
                    <td>{{ obj.descricao }}</td>
                    <td class="col-width-char05 right">{{ Funcoes.formatDecimal(obj.qtdhoras) }}</td>
                    <td class="col-width-char10 right">{{ Funcoes.formatDecimal(obj.aut_ttmo) }}</td>
                    <td class="col-width-char10 right">{{ Funcoes.formatDecimal(obj.qtdd) }}</td>
                    <td class="col-width-char15 right">{{ Funcoes.formatDecimal(obj.vlliquido) }}</td>
                    <td class="col-width-char15 right">{{ Funcoes.formatDecimal(obj.aut_vlautorizado) }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>


<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';

const emit = defineEmits(['close']);
const props = defineProps({idView: {type: Number, default: 0}});

const msgAlerta = ref(null);
const isLoading = ref(false);
const lsItensOrcamento = ref([]);
const lsItensServico = ref([]);
const objView = ref({});


async function baixarAnexo(idanexo) {
    if (!idanexo) {
        msgAlerta.value = 'ATENÇÃO: orçamento sem anexo vinculado.';
        return;
    }
    
    try{
        msgAlerta.value=null;
        isLoading.value = true;
        const r = await Api.genericPost('/main/solicitar/download', {id: idanexo});
        if (r.bolok === 1){
            const url = r.download_url;
            window.open(url, '_blank');
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value = false;}
}


const closeForm = () => {
    emit('close'); 
}


async function lerDados() {
    if (!props.idView > 0) return;
    try{
        isLoading.value = true;
        const req = await Api.genericPost('/dados/manut_os', {
            idmunicipio: globalStore.idmunicipio,
            id: props.idView});

        if (req.length > 0){
            Object.assign(objView.value, req[0]);
            
            const itensOrc = await Api.genericPost('/frota/manut_os/itens/orcamento', {
                idmunicipio: globalStore.idmunicipio,
                idreferencia: props.idView});
            lsItensOrcamento.value = itensOrc;
            
            const itensServ = await Api.genericPost('/frota/manut_os/itens/servicos', {
                idmunicipio: globalStore.idmunicipio,
                idreferencia: props.idView});
            lsItensServico.value = itensServ;
        }
    }catch (error){
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    }finally{
        isLoading.value = false;
    }
}


async function imprimirAF() {
    try{
        isLoading.value=true;
        msgAlerta.value=null;
        const dados = {
            nmrelatorio: 'manutOsAF',
            id: props.idView,
            idmunicipio: globalStore.idmunicipio,
            idusuario: globalStore.idusuario,
            idlogin: globalStore.idlogin};
        const response = await Api.genericReport(dados);
        const pdfBlob = new Blob([response], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}


function statusServico(item) {
    if (!objView.value?.execucao_data) {
        return 'Aguardando';
    }

    if (item.ckexecutado === 'S') {
        return 'Executado';
    }

    return 'Não executado';
}


onMounted(lerDados);
</script>